import { render, staticRenderFns } from "./ExibirErrosProtesto.vue?vue&type=template&id=0b5cb814&"
import script from "./ExibirErrosProtesto.vue?vue&type=script&lang=js&"
export * from "./ExibirErrosProtesto.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./ExibirErrosProtesto.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports